import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import LinkGallery from '../LinkGallery/LinkGallery';
import RawHtml from '../RawHtml/RawHtml';
import HelpButtons from '../Help/HelpButtons';
import useStyles from './MyAccountHelp.styles';
export const AMPLIENCE_KEY = 'component/my-account-help';
export const AMPLIENCE_KEY_FF = 'component/my-account-help-ff';
const MyAccountHelp = (props) => {
    const { title1, title2, body1, body2, linkGallery } = props;
    const { headingTag1 = 'H2', headingTag2 = 'H2' } = props;
    const { classes } = useStyles();
    const HeadingTag1 = headingTag1.toLowerCase();
    const HeadingTag2 = headingTag2.toLowerCase();
    return (_jsxs("div", { "data-testid": "MyAccountHelp-1", "data-type": "MyAccountHelp", className: classes.container, children: [!!title1 && _jsx(HeadingTag1, { className: classes.title, children: title1 }), !!body1 && _jsx(RawHtml, { className: classes.body, content: body1 }), _jsx(HelpButtons, { isCorporateEmail: false, classNames: classes, useCustomerSupportEmail: true }), !!title2 && _jsx(HeadingTag2, { className: classes.title, children: title2 }), !!body2 && _jsx(RawHtml, { className: classes.body, content: body2 }), !!linkGallery && _jsx(LinkGallery, Object.assign({}, linkGallery))] }));
};
export default MyAccountHelp;
